import { FC } from 'react'

import { Stack, Typography } from '@mui/material'

interface DetailedCellProps {
  value: string
  subValue: string
}

export const DetailedCell: FC<DetailedCellProps> = ({ value, subValue }) => {
  return (
    <Stack py={1}>
      <Typography>{value}</Typography>
      <Typography fontSize={10} fontWeight="bold" color="text.secondary">
        {subValue}
      </Typography>
    </Stack>
  )
}
